import { FC, useState } from "react";
import { AnimatePresence } from "framer-motion";

import {
  ProductionSceneLocationResource,
  ProductionSceneResource,
} from "@/types/resources";
import {
  InfoBlock,
  InfoHeadline,
  PlusButton,
} from "./ProductionScriptBlockInfo";
import LocationsModal from "./LocationsModal";
import Text from "@/components/Text";

interface Props {
  locations?: ProductionSceneLocationResource[][];
  scene: ProductionSceneResource;
  sceneNumber: number;
}

const SidebarLocations: FC<Props> = ({ locations, scene, sceneNumber }) => {
  const [showModal, setShowModal] = useState(false);

  const sceneLocations = locations?.[sceneNumber - 1];

  return (
    <>
      <InfoHeadline
        $type="smallBold"
        as="button"
        type="button"
        onClick={() => setShowModal(true)}
      >
        <PlusButton>
          <svg
            width="6"
            height="6"
            viewBox="0 0 6 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.75 0.749023C3.75 0.33481 3.41421 -0.000976562 3 -0.000976562C2.58579 -0.000976562 2.25 0.33481 2.25 0.749023V2.25098H0.749023C0.33481 2.25098 -0.000976562 2.58676 -0.000976562 3.00098C-0.000976562 3.41519 0.33481 3.75098 0.749023 3.75098H2.25V5.25095C2.25 5.66516 2.58579 6.00095 3 6.00095C3.41421 6.00095 3.75 5.66516 3.75 5.25095V3.75098H5.25095C5.66516 3.75098 6.00095 3.41519 6.00095 3.00098C6.00095 2.58676 5.66516 2.25098 5.25095 2.25098H3.75V0.749023Z"
              fill="currentColor"
            />
          </svg>
        </PlusButton>
        Locations
      </InfoHeadline>
      {!!sceneLocations?.length ? (
        sceneLocations.map((location) => (
          <InfoBlock key={location.id}>
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8 8.5C9.10457 8.5 10 7.60457 10 6.5C10 5.39543 9.10457 4.5 8 4.5C6.89543 4.5 6 5.39543 6 6.5C6 7.60457 6.89543 8.5 8 8.5Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M13 6.5C13 11 8 14.5 8 14.5C8 14.5 3 11 3 6.5C3 5.17392 3.52678 3.90215 4.46447 2.96447C5.40215 2.02678 6.67392 1.5 8 1.5C9.32608 1.5 10.5979 2.02678 11.5355 2.96447C12.4732 3.90215 13 5.17392 13 6.5V6.5Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <Text $type="smallBold" $color="black">
              {location.title}
            </Text>
          </InfoBlock>
        ))
      ) : (
        <InfoBlock>
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8 8.5C9.10457 8.5 10 7.60457 10 6.5C10 5.39543 9.10457 4.5 8 4.5C6.89543 4.5 6 5.39543 6 6.5C6 7.60457 6.89543 8.5 8 8.5Z"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13 6.5C13 11 8 14.5 8 14.5C8 14.5 3 11 3 6.5C3 5.17392 3.52678 3.90215 4.46447 2.96447C5.40215 2.02678 6.67392 1.5 8 1.5C9.32608 1.5 10.5979 2.02678 11.5355 2.96447C12.4732 3.90215 13 5.17392 13 6.5V6.5Z"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <Text $type="smallBold" $color="gray">
            No locations added
          </Text>
        </InfoBlock>
      )}
      <AnimatePresence>
        {!!showModal && (
          <LocationsModal scene={scene} onClose={() => setShowModal(false)} />
        )}
      </AnimatePresence>
    </>
  );
};

export default SidebarLocations;
